import { render, staticRenderFns } from "./ConcernElements.vue?vue&type=template&id=540300a2&"
import script from "./ConcernElements.vue?vue&type=script&lang=js&"
export * from "./ConcernElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports